import * as yup from 'yup'
import { IntlShape } from 'react-intl'

import { IRouteNameFormValues } from 'features/RoutingProjects/types'

export const schema = (intl: IntlShape): yup.SchemaOf<IRouteNameFormValues> => {
  return yup.object().shape({
    name: yup
      .string()
      .required(
        intl.formatMessage({
          id: 'routingProject.routes.name.form.required',
          defaultMessage: 'Required'
        })
      )
      .trim()
  })
}
